export default __webpack_public_path__ + "static/media/right-success-img.059903fd.gif";